import { defineComponent as _defineComponent } from 'vue'

import { onMounted } from 'vue';
import axios from 'axios';


export default /*#__PURE__*/_defineComponent({
  __name: 'GeovisearthOauthCallback',
  setup(__props) {

onMounted(() => {
  const urlParams = new URLSearchParams(window.location.search);
  const auth = urlParams.get('auth') || '';
  const signtext = urlParams.get('signtext') || '';
  const eauth = encodeURIComponent(auth);
  const esigntext = encodeURIComponent(signtext);
  axios.get(`/cartodb/geovisearth-oauth2/verify_signature?auth=${eauth}&signtext=${esigntext}`)
    .then((response) => {
      const { access_token, is_valid_signature } = response.data;
      if (!is_valid_signature) {
        console.error('Invalid signature');
        return;
      } else {
        localStorage.setItem('accessToken', access_token);
        localStorage.setItem('accountName', 'accountNamePlaceholder');
        window.location.href = `${process.env.VUE_APP_SSO_CALLBACK_URL}`;
      }
   });
});

return (_ctx: any,_cache: any) => {
  return " Geovisearth Authorizing... "
}
}

})